import { useData } from '../../../data/DataProvider'
import React, { useEffect, useState } from 'react'
import Skeleton from 'react-loading-skeleton'
import { GpPill, GpImagePlaceholder, GpButton } from '../../../components/gp'

const baseCardStyle = {
    background: '#FFFFFF',
    color: 'var(--gp-ink)',
    borderRadius: 'var(--gp-r-md)',
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
}

// `bordered` = standalone white Card (billing sidebar, on the white page);
// default = sits inside the green dashboard hero, no border needed.
const borderedExtra = {
    border: '1px solid var(--gp-hairline)',
    boxShadow: 'var(--gp-shadow-sm)',
}

const MyProperty = (props) => {
    const data = useData()
    const [isLoading, setIsLoading] = useState(true)
    const [userProperty, setUserProperty] = useState({})
    const cardStyle = props.bordered
        ? { ...baseCardStyle, ...borderedExtra }
        : baseCardStyle

    useEffect(() => {
        setIsLoading(true)
        if (Array.isArray(data.userProperties)) {
            if (data.userProperties.length > 0) {
                setUserProperty(data.userProperties[0])
            }
            setIsLoading(false)
        }
    }, [data.userProperties])

    if (isLoading) {
        return (
            <div style={cardStyle}>
                <Skeleton height="20px" borderRadius="6px" />
                <Skeleton height="150px" borderRadius="10px" />
                <Skeleton height="22px" width="90px" borderRadius="999px" />
            </div>
        )
    }

    if (Object.keys(userProperty).length === 0) {
        return (
            <div style={cardStyle}>
                <div
                    style={{
                        font: '400 14px/1.45 var(--gp-font)',
                        color: 'var(--gp-ink-mute)',
                    }}
                >
                    You haven't joined a property yet.
                </div>
                <GpButton
                    variant="primary"
                    onClick={() => props.setOpenPropertyModal(true)}
                >
                    Join Property
                </GpButton>
            </div>
        )
    }

    const status = userProperty.userPropertyStatus
    const statusLabel = status
        ? status.charAt(0).toUpperCase() + status.slice(1)
        : ''
    const isRequested = status === 'requested'
    const heroUrl = userProperty.hero?.length > 0 ? userProperty.hero[2].url : null

    return (
        <div style={cardStyle}>
            <div style={{ font: 'var(--gp-body-med)' }}>{userProperty.name}</div>

            {heroUrl ? (
                <img
                    alt="myProperty"
                    src={heroUrl}
                    style={{
                        width: '100%',
                        aspectRatio: '4 / 3',
                        objectFit: 'cover',
                        borderRadius: 'var(--gp-r-md)',
                        display: 'block',
                    }}
                />
            ) : (
                <GpImagePlaceholder label="property photo" aspect="4 / 3" />
            )}

            <div>
                <GpPill variant={isRequested ? 'warn' : 'default'}>
                    <span
                        style={{
                            width: 6,
                            height: 6,
                            borderRadius: '50%',
                            background: isRequested
                                ? 'var(--gp-warn)'
                                : 'var(--gp-brand)',
                            marginRight: 6,
                        }}
                    />
                    {statusLabel}
                </GpPill>
            </div>
        </div>
    )
}

export default MyProperty
